module.exports = __webpack_public_path__ + "img/line1.99a58841.svg";